import { Component } from '@angular/core';

@Component({
  selector: 'app-overlay-notification-demo',
  templateUrl: './overlay-notification-demo.component.html',
})
export class OverlayNotificationDemoComponent {}
